import { useEffect, useState } from 'react'
import { getControlAccounts, getStandardDefaults } from '../../api/master'
import { companyNow } from '../../utils/format'

// Helpers shared by the Accounting pages.

/** "2026-10" -> "October 2026" (or "October" with { year: false }). */
export const monthName = (ym, { year = true } = {}) => {
  const m = /^(\d{4})-(\d{2})$/.exec(String(ym || ''))
  if (!m) return ym || ''
  return new Date(+m[1], +m[2] - 1, 1).toLocaleDateString(undefined, year ? { month: 'long', year: 'numeric' } : { month: 'long' })
}

export const thisYm = (d = companyNow()) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`

/** The last n months, newest first, as "YYYY-MM". */
export const recentMonths = (n = 18, from = companyNow()) => Array.from({ length: n }, (_, i) => thisYm(new Date(from.getFullYear(), from.getMonth() - i, 1)))

export const STATUS_TONE = { Draft: 'muted', Posted: 'good', Voided: 'bad' }

/** The account types in chart order, for grouping choices. */
export const ACCOUNT_TYPES = [
  ['Asset', 'Assets'], ['Liability', 'Liabilities'], ['Equity', 'Equity'], ['Revenue', 'Revenue'], ['Expense', 'Expenses'],
]

/** The company's control accounts as { name: account_code } (PPE, AccumDep, Cash...). */
/** The standard account of each built-in default ({role: code}); {} until loaded. */
export function useStandardDefaults() {
  const [map, setMap] = useState({})
  useEffect(() => { getStandardDefaults().then((m) => setMap(m && typeof m === 'object' ? m : {})).catch(() => {}) }, [])
  return map
}

export function useControlAccounts() {
  const [map, setMap] = useState(null)
  useEffect(() => {
    getControlAccounts()
      .then((rows) => setMap(Object.fromEntries((Array.isArray(rows) ? rows : []).map((r) => [r.name, r.account_code]))))
      .catch(() => setMap({}))
  }, [])
  return map
}
